// Links viejos del Relámpago (/relampago/<id>/…): si ese torneo ya pasó a la base nueva (etapa 8 de los individuales,
// GET /api/ind/migrado/<id>), lleva a su página nueva; si no, muestra la pantalla vieja como siempre.
import { ReactNode, useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '';
const pub = axios.create();
const memo: Record<string, number | null> = {};

export default function MigradoRedirect({ a, children }: { a: (id: number) => string; children: ReactNode }) {
  const { torneoId = '' } = useParams<{ torneoId: string }>();
  const [nuevo, setNuevo] = useState<number | null | undefined>(torneoId in memo ? memo[torneoId] : undefined);
  useEffect(() => {
    if (!torneoId || torneoId in memo) return;
    pub.get<{ id: number }>(`${BACKEND_URL}/api/ind/migrado/${encodeURIComponent(torneoId)}`, { timeout: 8000 })
      .then(r => { memo[torneoId] = r.data.id; setNuevo(r.data.id); })
      .catch(() => { memo[torneoId] = null; setNuevo(null); });
  }, [torneoId]);
  if (nuevo === undefined) return <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--bg-page)' }}><Loader2 className="h-10 w-10 animate-spin" style={{ color: 'var(--lava-500)' }} /></div>;
  if (nuevo) return <Navigate to={a(nuevo)} replace />;
  return <>{children}</>;
}
